'use client';

import React from 'react';
import Header from './components/Header';
import Vision from './components/Vision';
import Features from './components/Features';
import Companies from './components/Companies';
import Projects from './components/Projects';
import Footer from './components/Footer';
import { LanguageProvider } from './contexts/LanguageContext';

// Main landing page component that assembles all sections
export default function Home() {
  return (
  <LanguageProvider>
      <div className="min-h-screen">
        <Header />
        
        {/* Wrapper for consistent width and styling */}
          <div className="w-full mx-auto">
            <Vision />
            <Features />
            <Companies />
            <Projects />
          </div>
        
        <Footer />
            </div>
    </LanguageProvider>
  );
}